declare const window: any;

export function injectInstallation() {
    if ('serviceWorker' in navigator) {
        window.addEventListener('load', () => {
            navigator.serviceWorker.register(window.location.protocol + '//' + window.location.host + '/service-worker.js');
        })
    
        window.installPrompt = null;
    
        window.addEventListener('beforeinstallprompt', (e:any) => {
            window.installabe = true;
            // Prevent Chrome 67 and earlier from automatically showing the prompt
            e.preventDefault();
    
            // Stash the event so it can be triggered later.
            window.installPrompt = e;
    
            console.log('browser install support detected!');
        });
    }
}